export const showAddressFields = (resource) =>
    !!resource?.address?.address || !!resource?.address?.city || !!resource?.address?.state || !!resource?.address?.zip
